import { graphql } from '../../../../graphql/generated';

export const CATALOG_QUERY = graphql(`
  query CatalogParameters($catalogId: ID!) {
    catalog(id: $catalogId) {
      id
      name
      catalogParameters {
        id
        useSpecimens
        specimens {
          id
          name
          classification
        }
        useSpecialRates
        specialRates {
          id
          shortName
        }
        useForms
        forms {
          id
          name
        }
        useDoctorBilling
        doctorBilling
        usePatientBilling
        patientBilling
        useLgDoctorBilling
        lgDoctorBilling
        useInsuranceDefinitions
        useLgInsuranceDefinitions
        usePriceDoctor
        priceDoctor
        usePricePatient
        pricePatient
        usePriceLgDoctor
        priceLgDoctor
        usePriceDeductible
        priceDeductible
        parameter {
          id
          shortName
          longName
          edifactNumber
          synonyms
          description
          link
          deactivated
          withoutParameters {
            id
            shortName
          }
          withParameters {
            id
            shortName
          }
          specimens {
            id
            name
            classification
          }
          specialRates {
            id
            shortName
          }
          forms {
            id
            name
          }
          doctorBilling
          patientBilling
          lgDoctorBilling
          priceDoctor
          pricePatient
          priceLgDoctor
          priceDeductible
        }
      }
    }
  }
`);
